import SsoLoggedOutView from '../../components/Login/SsoLoggedOutView';

const ssoScreens = { LogoutSso: { component: SsoLoggedOutView } };

export default ssoScreens;
